import { AccountAccess, CompanyAccess } from '@/api/__generated__/webApi';
import {
  AccessClassification,
  AccountAccessData,
  CompanyAccessData,
} from '@/api/accesses';

export const addClassificationAccess = (
  accesses: (CompanyAccess | AccountAccess)[],
  classification: AccessClassification
): (AccountAccessData | CompanyAccessData)[] => {
  return accesses.map((access) => ({ ...access, classification }));
};
